import { render, staticRenderFns } from "./CartLink.vue?vue&type=template&id=cf97f7e4&scoped=true&"
import script from "./CartLink.vue?vue&type=script&lang=js&"
export * from "./CartLink.vue?vue&type=script&lang=js&"
import style0 from "./CartLink.vue?vue&type=style&index=0&id=cf97f7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf97f7e4",
  null
  
)

export default component.exports